import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
interface BonusProps {
  number: string;
  title: string;
  image: string;
  description: string;
  value: string;
}
export function BonusCard({
  number,
  title,
  image,
  description,
  value
}: BonusProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} whileHover={{
    y: -10
  }} className="bg-white border-2 border-blue-100 rounded-3xl overflow-hidden flex flex-col shadow-lg hover:shadow-2xl hover:border-blue-200 transition-all duration-300 relative group" data-id="element-69" data-mp="2x5093p9hae31">
      {/* Gift Ribbon */}
      <div className="absolute top-0 left-0 z-30 pointer-events-none overflow-hidden w-32 h-32" data-id="element-70" data-mp="2e7yx3khibdpl">
        <div className="absolute top-6 -left-10 w-40 py-1 bg-[#d97706] text-white text-[10px] font-black text-center uppercase tracking-widest -rotate-45 shadow-lg border-y border-white/20" data-id="element-71" data-mp="1hlvopzcbzaoh">
          ¡REGALO!
        </div>
      </div>

      <div className="absolute top-4 right-4 z-20" data-id="element-72" data-mp="1s2iafhw06xh8">
        <motion.div animate={{
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="bg-blue-600 text-white p-2 rounded-full shadow-lg" data-id="element-73" data-mp="1s3tlm2rs37id">
          <Gift size={16} data-id="element-74" data-mp="1df6yhevwtbgl" />
        </motion.div>
      </div>

      <div className="aspect-[4/3] overflow-hidden bg-blue-50 relative" data-id="element-75" data-mp="19ck2d1s7h4dl">
        <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-76" data-mp="19b8zd46l40nj" />
        <div className="absolute inset-0 bg-gradient-to-t from-blue-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-77" data-mp="zfe8xmw4d1a7" />
      </div>

      <div className="p-8 flex-grow flex flex-col relative" data-id="element-78" data-mp="2tsdudwn6kppe">
        <div className="flex items-center gap-2 mb-3" data-id="element-79" data-mp="2tt6vagzgkkzm">
          <span className="bg-blue-100 text-blue-600 font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest" data-id="element-80" data-mp="s2oly2q1tnhg">
            BONO {number}
          </span>
          <Sparkles size={14} className="text-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-81" data-mp="wvrce1zj4gtf" />
        </div>

        <h3 className="text-xl font-black text-blue-950 mb-4 leading-tight group-hover:text-blue-600 transition-colors" data-id="element-82" data-mp="n4n05a18na2a">
          {title}
        </h3>
        <p className="text-blue-800/70 text-sm mb-6 flex-grow" data-id="element-83" data-mp="1fsisy3noshts">{description}</p>
        <div className="pt-4 border-t border-blue-50" data-id="element-84" data-mp="1fqg5nrdx52sr">
          <p className="text-blue-300 text-xs line-through" data-id="element-85" data-mp="10uqfri5m45ir">
            VALORADO EN {value}
          </p>
          <p className="text-blue-600 font-black text-lg" data-id="element-86" data-mp="15t1qdv3qek21">HOY GRATIS</p>
        </div>
      </div>
    </motion.div>;
}